import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Alkalmazás hiba:', error, errorInfo);
    }
    render() {
        if (this.state.hasError && this.state.error) {
            return (_jsxs("div", { style: { padding: '2rem', margin: '2rem', background: '#fff3cd', border: '2px solid #ffc107', borderRadius: '8px' }, children: [_jsx("h2", { children: "Hiba t\u00F6rt\u00E9nt" }), _jsx("p", { children: this.state.error.message }), _jsx("button", { onClick: () => window.location.reload(), style: { padding: '0.5rem 1rem', background: '#ffc107', border: 'none', cursor: 'pointer' }, children: "Oldal \u00FAjrat\u00F6lt\u00E9se" })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
